import { FC } from 'react';
import { TimePicker } from 'antd';
import moment from 'moment';

interface IProps {
  className?: string;
  value: string;
  onSelect: (value: any) => void;
  minuteStep?: number;
  disabled?: boolean;
  disabledHours?: () => Array<number>;
  disabledMinutes?: () => Array<number>;
}

const CustomTimePicker: FC<IProps> = ({
  className = '',
  value,
  onSelect,
  minuteStep = 5,
  disabled = false,
  disabledHours = () => [1, 2, 3, 4, 5, 6, 7, 8],
  disabledMinutes = () => [],
}) => {
  return (
    <TimePicker
      className={className}
      value={value ? moment(value, 'HH:mm') : undefined}
      onChange={onSelect}
      minuteStep={minuteStep}
      format="HH:mm"
      disabledHours={disabledHours}
      disabledMinutes={disabledMinutes}
      disabled={disabled}
    />
  );
};

export default CustomTimePicker;
